// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text_value[data-v-0ad35644]{background-color:#fff;padding:.3rem 1rem}.el-button-group>.el-button[data-v-0ad35644]{float:none}", ""]);
// Exports
module.exports = exports;
